import { get } from 'lodash';
import * as React from 'react';
import { getContinueWithoutLoginUrl } from '../../../../config/ConfigService';
import { IContent } from '../../../../login/interfaces';
import { getWindow } from '../../../../window/Window';
import { fireErrorAnalytics } from './errorAnalytics';
import { IFrameErrorView } from './IFrameErrorView';
import { navigation } from '@origin-digital/reporting-client';

const content: IContent = require('../../../../content.json');

interface IFrameErrorPageProps {
  match?: any;
}

const IFrameErrorPage: React.FC<IFrameErrorPageProps> = ({ match }) => {
  React.useEffect(() => {
    if (match.params.code === 'too_many_attempts') {
      navigation('screen', {
        currentUri: 'https://www.originenergy.com.au/sign-up/login/error-max-attempts',
        friendlyUri: 'originenergy:sign-up:login-modal:error-max-attempts',
      });
    } else {
      fireErrorAnalytics(match.params.code);
    }
  }, []);

  const { code: errorMatchParam } = match.params;
  const error = get(
    content.iframe_login_errors,
    errorMatchParam,
    content.iframe_login_errors.generic_error,
  );

  return (
    <IFrameErrorView
      title={error.heading}
      errorMessage={error.body}
      onContinueWithoutLogin={continueWithoutLogin}
    />
  );
};

const continueWithoutLogin = () => {
  getWindow().location.assign(getContinueWithoutLoginUrl());
};

export { IFrameErrorPage };
